import { defineComponent as _defineComponent } from 'vue'
import { fetchTokenMetadata } from "@/api/endpoints";
import { useCacheStore } from "@/pinia";
import {
	getMintImageURL,
	getSupplyNumber,
	IToken,
	TOKEN22_PROGRAM_ID,
} from "@/shared";
import { web3 } from "@project-serum/anchor";
import { onMounted, ref, withDefaults } from "vue";

// props
interface IProps {
	mint: string;
	program?: web3.PublicKey;
	supply?: number;
	onready?: ({ token, error }: any) => Promise<void>;
	skipPrice?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TokenLoad',
  props: {
    mint: null,
    program: { default: () => TOKEN22_PROGRAM_ID },
    supply: { default: 0 },
    onready: { type: Function, default: async () => {} },
    skipPrice: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { mint: string, program: web3.PublicKey, supply: number, onready: ({ token, error }: any) => Promise<void>, skipPrice?: boolean };



// store
const cacheStore = useCacheStore();

// data
const loading = ref<boolean>(true);
const error = ref<boolean>(false);
const token = ref<IToken | null>(null);

// methods
async function init() {
	if (cacheStore.tokenList[props.mint]) {
		token.value = cacheStore.tokenList[props.mint];
		props?.onready({ error: error.value, token: token.value });
		loading.value = false;
		return;
	}

	try {
		if (!props.skipPrice) {
			await cacheStore.fetchMintPriceUSD(props.mint);
		}

		const primitive = await fetchTokenMetadata(props.mint);

		if (primitive.error) {
			error.value = true;
		}

		token.value = TokenDTO(primitive);

		cacheStore.addTokenList(token.value);
	} catch (e: any) {
		error.value = true;
		throw new Error(e);
	} finally {
		await props?.onready({ error: error.value, token: token.value });
		loading.value = false;
	}
}
function TokenDTO(primitive: any): IToken {
	return {
		address: new web3.PublicKey(props.mint),
		amount: 0,
		decimals: primitive?.decimals,
		extensions: [],
		mint: props.mint,
		name: primitive?.name,
		programID: new web3.PublicKey(props.program),
		supply: getSupplyNumber(props.supply),
		symbol: primitive?.symbol,
		image:
			primitive.imageUri.trim() !== ""
				? primitive.imageUri
				: getMintImageURL(props.mint),
	};
}

// setup
onMounted(init);

return { __sfc: true,props, cacheStore, loading, error, token, init, TokenDTO }
}

})